import { render, staticRenderFns } from "./TimeDurEvent.vue?vue&type=template&id=64240efa&"
import script from "./TimeDurEvent.vue?vue&type=script&lang=js&"
export * from "./TimeDurEvent.vue?vue&type=script&lang=js&"
import style0 from "./TimeDurEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports